import { DeleteOutlined } from '@ant-design/icons';
import { DivToast } from '@components/common/WapperNotification';
import { ThunkDispatch } from '@reduxjs/toolkit';
import {
  changeOpenUpdateOrder,
  changeQActionOrder,
  removeHistoryNoti,
  removeNotification,
  updateOpenHistoryNoti,
  updateOrderSelected
} from '@slice/orderManager.slice';
import { Tooltip } from 'antd';
import { RootState } from 'app/store';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

export default function ListHistoryNotifies() {
  const { t } = useTranslation();
  const listHistoryNoti = useSelector((state: RootState) => state.orderManager.listHistoryNotis);
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const history = useNavigate();

  // cần xử lý như dạng này nếu đơn này chưa có trong list đơn bên menu quản lý đơn //

  const handleDetail = (maDonHang: string, orderTypeId?: number) => {
    console.log('maDonHang', maDonHang);
    dispatch(updateOrderSelected(maDonHang));
    dispatch(changeOpenUpdateOrder(true));
    return;
  };

  const handleMenu = (maDonHang: string, orderTypeId?: number) => {
    // toast.remove(maDonHang);
    history('/quan-ly-don-hang' + `?maDonHang=${maDonHang}`);
  };

  const handleQActions = (maDonHang: string, orderTypeId?: number) => {
    console.log('maDonHang', maDonHang);
    dispatch(updateOrderSelected(maDonHang));
    dispatch(changeQActionOrder(true));
  };

  const handleRemoveAllNotify = () => {
    console.log('Remove AllNotify');
    const notifyC = { maDonHang: undefined, clearAll: true };
    dispatch(removeHistoryNoti(notifyC));
  };

  const handleRemoveNotify = (maDonHang: string) => {
    console.log('Remove Notify');
    const notifyC = { maDonHang: maDonHang, clearAll: false };
    dispatch(removeHistoryNoti(notifyC));
  };

  // tạo style custom màu theo thêm luôn!!
  const renderListNotification = useMemo(() => {
    return listHistoryNoti.map((notify, index) => (
      <div className="flex py-2 hover:text-gray-300 space-x-2" key={notify.maDonHang}>
        <div className="text-lg font-semibold">{index + 1}</div>
        <DivToast
          notification={notify}
          handleDetail={handleDetail}
          handleMenu={handleMenu}
          handleQActions={handleQActions}
        />
        <div onClick={() => handleRemoveNotify(notify.maDonHang)} className="cursor-pointer hover:!text-red-500">
          X
        </div>
      </div>
    ));
  }, [listHistoryNoti]);

  return (
    <div
      onMouseLeave={() => dispatch(updateOpenHistoryNoti())}
      className="ffs-text flex flex-col space-y-2 divide-y divide-white align-middle items-center p-3 max-h-[60vh] overflow-y-auto"
    >
      <div className="w-full flex justify-between">
        <>
          <div className="font-semibold !text-sm ">
            {listHistoryNoti.length != 0 ? (
              <div className="flex items-center">
                {' '}
                {t('Notification.TitleHistory') + ' - ' + listHistoryNoti.length} {'  '}
                <Tooltip placement="topRight" title={t('Notification.CloseAllHis')}>
                  <div className="cursor-pointer" onClick={() => handleRemoveAllNotify()}>
                    {' '}
                    <DeleteOutlined
                      rev={''}
                      className="hover:text-orange-700"
                      style={{ fontSize: '16px', color: 'red', transform: 'translateY(-3px)' }}
                    />
                  </div>
                </Tooltip>
              </div>
            ) : (
              t('Notification.NoHistoryNotify')
            )}
          </div>{' '}
          <Tooltip placement="topLeft" title={t('Notification.CloseHistory')}>
            <div className="cursor-pointer" onClick={() => dispatch(updateOpenHistoryNoti(false))}>
              ❎
            </div>
          </Tooltip>
        </>
      </div>
      {renderListNotification}
    </div>
  );
}
